module.exports = __webpack_public_path__ + "static/media/copernicus_insitu_logo.72981076.svg";